// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__D58gY","thumbnailDesktop":"styles_thumbnailDesktop__xWuJT","extendThumbnail":"styles_extendThumbnail__qqQkv"};